/**
 * Tarjetas del inicio movil por permiso efectivo (design.md §22.3).
 * Lista unica sin secciones por rol; la API vuelve a autorizar cada operacion.
 */
import type { MobileIconName } from '@/components/MobileIcon';

export type MobileCard = {
  key: string;
  label: string;
  description: string;
  icon: MobileIconName;
  path: string;
  permissionCode?: string;
  permissionAnyCodes?: readonly string[];
};

export const homeCards: MobileCard[] = [
  {
    key: 'panel',
    label: 'Mi panel',
    description: 'Indicadores y resumen de tus ventas',
    icon: 'bar_chart',
    path: '/m/dashboard',
    permissionCode: 'dashboard.view',
  },
  {
    key: 'requirement-new',
    label: 'Nuevo requerimiento',
    description: 'Registra el pedido del cliente en campo',
    icon: 'assignment_add',
    path: '/m/requirements/new',
    permissionCode: 'customer_requirements.create',
  },
  {
    key: 'requirements',
    label: 'Mis requerimientos',
    description: 'Consulta y sigue tus requerimientos',
    icon: 'assignment',
    path: '/m/requirements',
    permissionCode: 'customer_requirements.view',
  },
  {
    key: 'quote-generator',
    label: 'Cotizador',
    description: 'Compone el requerimiento del cliente',
    icon: 'point_of_sale',
    path: '/m/quote-builder',
    permissionCode: 'quotations.create',
  },
  {
    key: 'budgets',
    label: 'Presupuestos',
    description: 'Nro., cliente y total de tus presupuestos',
    icon: 'calculate',
    path: '/m/budgets',
    permissionCode: 'budgets.view',
  },
  {
    key: 'clients',
    label: 'Clientes',
    description: 'Crea y consulta clientes',
    icon: 'contacts',
    path: '/m/clients',
    permissionCode: 'clients.view',
  },
  {
    key: 'tasks',
    label: 'Mis tareas',
    description: 'Tareas que te asignaron para aprobar o revisar',
    icon: 'task_alt',
    path: '/m/tasks',
    permissionCode: 'workflow_tasks.view_own',
  },
];

export function visibleCards(
  cards: MobileCard[],
  hasPermission: (code: string) => boolean,
): MobileCard[] {
  return cards.filter(
    (card) =>
      (!card.permissionCode || hasPermission(card.permissionCode)) &&
      (!card.permissionAnyCodes || card.permissionAnyCodes.some(hasPermission)),
  );
}

export type BottomTab = {
  key: string;
  label: string;
  icon: MobileIconName;
  path: string;
  permissionCode?: string;
  permissionAnyCodes?: readonly string[];
};

export const bottomTabs: BottomTab[] = [
  { key: 'home', label: 'Inicio', icon: 'home', path: '/m' },
  {
    key: 'create',
    label: 'Crear',
    icon: 'add_circle',
    path: '/m/requirements/new',
    permissionCode: 'customer_requirements.create',
  },
  {
    key: 'quote-generator',
    label: 'Cotizar',
    icon: 'request_quote',
    path: '/m/quote-builder',
    permissionCode: 'quotations.create',
  },
  { key: 'more', label: 'Más', icon: 'more_horiz', path: '/m/more' },
];

export function visibleTabs(
  tabs: BottomTab[],
  hasPermission: (code: string) => boolean,
): BottomTab[] {
  return tabs.filter(
    (tab) =>
      (!tab.permissionCode || hasPermission(tab.permissionCode)) &&
      (!tab.permissionAnyCodes || tab.permissionAnyCodes.some((code) => hasPermission(code))),
  );
}
